import { useLayoutEffect } from 'react';
import { Outlet } from 'react-router';
import appCssUrl from '@apply-scss/app.scss?url';
import brokerCssUrl from '@apply-scss/applications/broker.scss?url';
import { applyCssIfChanged } from './cssUtils';

export function oldAdminLoader() {
    window.__LAYOUT_CSS__ = [appCssUrl, brokerCssUrl];
    return null;
}

export const BrokerScss = () => {
    useLayoutEffect(() => {
        applyCssIfChanged([appCssUrl, brokerCssUrl]);
    }, []);
    return <Outlet />;
};
